import React from 'react';
import { Label } from '../../components/schedule/sidebar';

export default function HeaderLabel({ row }) {
  return <Label>{row.label}</Label>;
}
